<template>
  <div class="d-flex ga-4 justify-end">
    <TooltipIcon
      v-if="passing === true"
      color="green"
      icon="check_circle"
      icon-style="solid"
      text="Correct"
    />

    <TooltipIcon
      v-if="passing === false"
      color="red"
      icon="cancel"
      icon-style="solid"
      text="Incorrect"
    />

    <TooltipIcon
      v-if="published === false"
      :color="unpublishedColor"
      icon="hide_source"
      icon-style="solid"
      text="Unpublished"
    />

    <TooltipIcon
      v-if="mandatory"
      :color="statusColor('red')"
      aria-label="required"
      icon="emergency"
      icon-style="solid"
      text="Required"
    />

    <TooltipIcon
      v-if="conditional"
      :color="statusColor()"
      :text="conditionsTooltipText"
      aria-label="Conditional"
      icon="dynamic_form"
      icon-style="solid"
    />

    <TooltipIcon
      v-if="verification"
      :color="statusColor()"
      icon="add_moderator"
      icon-style="solid"
      text="Requires verification"
    />

    <TooltipIcon
      v-if="income === true"
      :color="statusColor('green')"
      icon="paid"
      icon-style="solid"
      text="Income"
    />
    <TooltipIcon
      v-if="published === true"
      :color="statusColor('green')"
      icon="circle"
      icon-style="solid"
      text="Published"
    />
  </div>
</template>

<script setup>
import TooltipIcon from '@/shared/components/TooltipIcon.vue';

const props = defineProps({
  conditional: {
    type: Boolean,
    default: null,
  },
  conditionsFailed: {
    type: Boolean,
    default: null,
  },
  mandatory: {
    type: Boolean,
    default: null,
  },
  passing: {
    type: Boolean,
    default: null,
  },
  income: {
    type: Boolean,
    default: null,
  },
  published: {
    type: Boolean,
    default: null,
  },
  verification: {
    type: Boolean,
    default: null,
  },
});

const unpublishedColor = 'gray';

function statusColor(color = 'primary') {
  return !props.published || props.conditionsFailed ? unpublishedColor : color;
}

const conditionsTooltipText = computed(() => {
  return props.conditionsFailed ? 'Conditions were not met' : 'Conditional';
});
</script>
